//import rpcRequestFake from './rpc-request-fake';
import rpcRequest from "./rpc-request-real";

export default rpcRequest;
